
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ärzte nennen das nächtliche Zähneknirschen Bruxismus. `}<M mdxType="M">{`«Schätzungsweise 30 Prozent der Bevölkerung tun es, oft im Schlaf»`}</M>{`, sagt ­Dominik Ettlin, Leiter des Bereichs Kaufunktionsstörung am Zentrum für Zahnmedizin der Uni Zürich. Darunter sind mehrheitlich Frauen. Auch 14 bis 18 Prozent der Kinder und Jugendlichen knirschen mit den Zähnen. Anlass zur Panik ist das aber nicht: Die meisten Knirscher haben keine ­Beschwerden. `}<br /><br />{`
Die Ursachen sind vielfältig: `}<M mdxType="M">{`Alltagsstress und unterdrückte Aggressionen könnten so verarbeitet werden, aber auch Angststörungen und Depressionen kommen infrage.`}</M>{` Zurzeit wird wissenschaftlich erforscht, ob die Ursache für das Zähneknirschen im Gehirn zu suchen ist und inwiefern ein fehlerhaftes Zusammenspiel der Zähne des Ober- und Unterkiefers zu dieser unbewussten, nächtlichen Aktion beiträgt. `}<br /><br />{`
Zähneknirschen kann unangenehme Auswirkungen haben.`}<M mdxType="M">{`Die Zähne leiden, denn beim nächtlichen Knirschen können extreme Kräfte auf die Zähne wirken`}</M>{`, x-mal stärker als beim normalen Kauen. Das nützt den Zahnschmelz stark ab. Eine verspannte Kaumuskulatur und ausstrahlende Schmerzen bis in die Nacken-Kopf-Region können die Folgen sein. Knirschschienen schonen die Zähne. Um sich das Knirschen abzugewöhnen, raten Therapeuten zu Entspannungstechniken.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;